import UserCard from './user-card.vue';

export default UserCard;